import React from "react";

export function Count({
  count,
  active = true,
  className,
  space = true,
}: {
  count: number | string;
  active?: boolean;
  className?: string;
  space?: boolean;
}) {
  return (
    <span
      className={`${active ? "bg-secondary text-white" : "bg-gray-100 text-gray-400"} ${className} ${space && "ml-1.5"} rounded-full py-0.5 px-2.5 text-xs font-medium inline-flex`}>
      {count}
    </span>
  );
}
